import React from "react";
import { StreamConnectionState, useZLBoltStreamState } from ".";
import { useZLBolt, useZLBoltOptions } from "./ZLBolt";
// typing style to React.CSSProperties causes:
// error TS2742: The inferred type of 'ZLBoltStreamContainer' cannot be named without a reference to '/node_modules/csstype'. This is likely not portable. A type annotation is necessary.
export function ZLBoltStreamContainer(props) {
    var _a, _b, _c;
    const zlBolt = useZLBolt();
    const options = useZLBoltOptions();
    const state = useZLBoltStreamState();
    const ref = React.useCallback((e) => {
        if (e && state == StreamConnectionState.Ready) {
            zlBolt === null || zlBolt === void 0 ? void 0 : zlBolt.moveStream(sanitizedProps.id, console.warn);
        }
    }, []);
    if ((options === null || options === void 0 ? void 0 : options.parent) !== undefined && typeof (options.parent) !== "string") {
        throw new Error("Don't create a ZLBoltStreamContainer instance if your passing an explicit element reference as the parent");
    }
    const sanitizedProps = Object.assign(Object.assign({}, props), { style: Object.assign(Object.assign({}, ((_a = props.style) !== null && _a !== void 0 ? _a : {})), { position: "relative" }), id: (_b = props.id) !== null && _b !== void 0 ? _b : options === null || options === void 0 ? void 0 : options.parent, ref });
    delete sanitizedProps.tag;
    return React.createElement((_c = props.tag) !== null && _c !== void 0 ? _c : "div", sanitizedProps);
}
